import {useEffect, useRef} from 'react';
const Dropdown =({ dataObj, className="", selectedItem=null, levels=[""], multiSelect=false, dropdownKey=[], placeholder, selectItem })=>{
	const dropdown = useRef(null);
	const isInit = useRef(false);
	useEffect(()=>{
		if(dropdown.current && !isInit.current){
			
			const dropdownItem = new MultiLayerDropdown(dropdown.current, {
		        searchPlaceholder: placeholder,
		        levels: levels,
		        keys: dropdownKey
		    });
	    	dropdownItem.initializeData(dataObj);
	    	isInit.current = true;
	    	
	    	if(selectedItem){
	    		const objKey = Object.keys(selectedItem)[0];
				const objVal = selectedItem[Object.keys(selectedItem)[0]];
		    	dropdownItem.selectItems({
		    		[objKey]: [objVal]
		    	});
	    	}

	    	(dropdown.current).addEventListener('itemClick', (e)=>{
	    		// const selectedVal = dropdownItem.getValues();
	    		if(multiSelect === true){
		    		const selectedVal = dropdownItem.getValues();
			        if (Object.values(selectedVal).length > 0) {
			        	selectItem(selectedVal)
			        }
	    		}else{
	    			const selectedVal = dropdownItem.getKeyValuesOnly(dropdownKey[0]);
			        if (selectedVal.length > 0) {
			        	let valObj = selectedVal[0]
			        	let key = Object.keys(valObj)[0];
			        	let val = Object.values(...Object.values(valObj));
			        	selectItem({ [key]: val });
			        }
	    		}
	    	})

		}
	},[dataObj]);

	return (
		<div className={className} data-multi-select={multiSelect} ref={dropdown}></div>
	)
}

export default Dropdown;